import { FC } from 'react';
import Loader from './loader';

const SmallLoader: FC<{ size: string; className?: string }> = props => {
    return <Loader {...props} showBackground={false} />;
};

export default SmallLoader;
